import React, { HTMLInputTypeAttribute } from "react";
import { TextField, FormControl, FormLabel } from "@mui/material";
import { Controller, FieldValues } from "react-hook-form";

interface AGInputProps {
  name: string;
  label: string;
  control: any; // You can replace `any` with proper type if needed
  error?: string;
  rules?: Partial<FieldValues>; // Validation rules
  type?: HTMLInputTypeAttribute;
  maxLength?: number;
  minLength?: number;
  disabled?: boolean;
  min?: number;
  max?: number;
  step?: number;
  required?: boolean;
  endAdornment?: any;
  multiline?: any;
  onChange?: (e: any) => void;
  placeholder?: string;
}

const AGInput: React.FC<AGInputProps> = ({
  type = "text",
  name,
  label,
  control,
  error,
  rules,
  maxLength = 255,
  minLength = 1,
  disabled = false,
  min = 0,
  endAdornment,
  max,
  required = false,
  step = 0.1,
  multiline,
  onChange,
  placeholder = "",
  ...rest
}) => {
  return (
    <FormControl error={!!error} fullWidth margin="normal">
      <FormLabel className="text-black mb-1 font-semibold  text-sm">
        {label}
      </FormLabel>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            type={type}
            multiline={multiline}
            autoComplete="off"
            required={required}
            inputProps={{
              maxLength: maxLength,
              minLength: minLength,
              min: min,
              max: max,
              step,
            }}
            onChange={(e) => {
              field.onChange(e);
              onChange && onChange(e);
            }}
            InputProps={{
              endAdornment: endAdornment,
            }}
            variant="outlined"
            error={!!error}
            size="small"
            helperText={error || ""}
            {...rest}
          />
        )}
      />
    </FormControl>
  );
};

export default AGInput;
